<template>
    <div>
        <!-- section start -->
        <section>
            <div class="inner row3 flex">
                <article class="wd50">
                    <div class="aRow3 trendSection1">
                        <h1>고령 소비자 서비스</h1>
                        <p>
                            <strong>
                                고령소비자를 위한 <br class="mobileBr">맞춤형 정보제공 이란?
                            </strong>
                        </p>
                        <p>
                            고령소비자 등 기술수용도가 취약한 대상에게 기업의 다양한 제품 및 서비스를 개인의 특성, 욕구 등을 분석하여 맞춤형으로 1:1 연결 및 정보를 제공하고, 기업에게는 적합한 소비자 추천 및 시장 정보를 전달해주는 서비스 입니다.
                        </p>
                        <div class="rowBtn2">
                            <router-link class="mainBgBtn btnFont wdCustom" to="/serviceSearch">제품·서비스 검색</router-link>
                        </div>
                    </div>
                </article>
                <article class="wd50 mobileReset">
                    <div class="alignR">
                        <figure>
                            <img src="../../assets/images/cmmnMain/고령소비자서비스이미지.png" alt="고령소비자서비스 이미지">
                        </figure>
                    </div>
                </article>
            </div>
        </section>
        
        <section>
            <div class="inner row2">
                <h1 class="mainTitle">서비스 이용방법</h1>
                <article class="mobileReset">
                    <div class="usedServiceBox aRow6 flex">
                        <div class="ServiceBoxItem counterNo1">
                            <figure>
                                <img src="../../assets/images/cmmnMain/매칭정보획득아이콘.png" alt="매칭정보획득 아이콘 이미지">
                                <figcaption>
                                    매칭정보 획득
                                </figcaption>
                            </figure>
                        </div>
                        <div class="ServiceBoxItem counterNo2">
                            <figure>
                                <img src="../../assets/images/cmmnMain/소비자욕구파악아이콘.png" alt="소비자욕구파악 아이콘 이미지">
                                <figcaption>
                                    소비자 욕구파악
                                </figcaption>
                            </figure>
                        </div>
                        <div class="ServiceBoxItem spanFontItem counterNo3">
                            <figure>
                                <img src="../../assets/images/cmmnMain/제품수요파악아이콘.png" alt="제품수요파악 아이콘 이미지">
                                <figcaption>
                                    제품수요 파악
                                    <span>
                                        기업·제품 서비스 정보 제공
                                    </span>
                                </figcaption>
                            </figure>
                        </div>
                        <div class="ServiceBoxItem redFont counterNo4">
                            <figure>
                                <img src="../../assets/images/cmmnMain/맞춤형제품선택아이콘.png" alt="맞춤형제품선택 아이콘 이미지">
                                <figcaption>
                                    맞춤형 제품 선택
                                </figcaption>
                            </figure>
                        </div>
                    </div>
                    <div class="moreBtnBox">
                        <button>매뉴얼 다운</button>
                    </div>
                    <div class="row9 imgWidth100">
                        <figure>
                            <img src="../../assets/images/cmmnMain/lowtech.png" alt="lowtech">
                        </figure>
                    </div>
                </article>
                <article class="mobileBlock">
                    <div class="mobileOldConsumer">
                        <VueSlickCarousel v-bind="settings">
                            <div class="ServiceBoxItem counterNo1">
                                <figure>
                                    <img src="../../assets/images/cmmnMain/매칭정보획득아이콘.png" alt="매칭정보획득 아이콘 이미지">
                                    <figcaption>
                                        매칭정보 획득
                                    </figcaption>
                                </figure>
                            </div>
                            <div class="ServiceBoxItem counterNo2">
                                <figure>
                                    <img src="../../assets/images/cmmnMain/소비자욕구파악아이콘.png" alt="소비자욕구파악 아이콘 이미지">
                                    <figcaption>
                                        소비자 욕구파악
                                    </figcaption>
                                </figure>
                            </div>
                            <div class="ServiceBoxItem spanFontItem counterNo3">
                                <figure>
                                    <img src="../../assets/images/cmmnMain/제품수요파악아이콘.png" alt="제품수요파악 아이콘 이미지">
                                    <figcaption>
                                        제품수요 파악
                                        <span>
                                            기업·제품 서비스 정보 제공
                                        </span>
                                    </figcaption>
                                </figure>
                            </div>
                            <div class="ServiceBoxItem redFont counterNo4">
                                <figure>
                                    <img src="../../assets/images/cmmnMain/맞춤형제품선택아이콘.png" alt="맞춤형제품선택 아이콘 이미지">
                                    <figcaption>
                                        맞춤형 제품 선택
                                    </figcaption>
                                </figure>
                            </div>
                        </VueSlickCarousel>
                    </div>
                    <div class="row9 imgWidth100">
                        <figure>
                            <img src="../../assets/images/cmmnMain/lowtech.png" alt="lowtech">
                        </figure>
                    </div>
                </article>
            </div>
        </section>
        
    </div>   
</template>

<script>
//import UsedService from '@/components/layout/UsedService/UsedService'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'corpNetworking',
    components: {
        VueSlickCarousel
    },
    data () {
        return {
            currentTab: 0,
            tabs: ['1', '2', '3', '4', '5', '6', '7'],
            settings: {
                dots:true,
                arrows:false,
                speed:1500,
                infinite:true,
                autoplay:true,
                autoplaySpeed:5000,
                pauseOnDotsHover:true,
                pauseOnHover:true,
                "responsive": [
                    {
                    "breakpoint": 560,
                    "settings": {
                        "slidesToShow": 1,
                        "slidesToScroll": 1,
                    }
                    },
                ]
            }
        }
    }
}

</script>

<style scoped>
    .usedServiceBox {
        margin: 0 auto;
        justify-content: center;
    }
    .usedServiceBox .ServiceBoxItem {
        padding: 0 2.5rem;
        position: relative;
    }
    .usedServiceBox .ServiceBoxItem::before {
        content: "";
        color: #FFFFFF;
        font-weight: 500;
        font-size: 2.6rem;
        line-height: 4rem;
        width: 4rem;
        height: 4rem;
        border-radius: 2rem;
        left: 50%;
        margin-left: -2rem;
        background: #26336A;
        top: -8rem;
        position: absolute;
        text-align: center;
        z-index: 2;
    }
    .usedServiceBox .ServiceBoxItem::after {
        content: '';
        position: absolute;
        background: #DCDCDC;
        width: 100%;
        left: 50%;
        height: 1px;
        top: -6rem;
        z-index: 1;
    }
    .usedServiceBox .ServiceBoxItem.counterNo4::after {
        display: none;
    }
    .usedServiceBox .ServiceBoxItem.counterNo1::before {
        content: '1';
    }
    .usedServiceBox .ServiceBoxItem.counterNo2::before {
        content: '2';
    }
    .usedServiceBox .ServiceBoxItem.counterNo3::before {
        content: '3';
    }
    .usedServiceBox .ServiceBoxItem.counterNo4::before {
        content: '4';
    }
    .usedServiceBox .ServiceBoxItem figcaption {
        margin: 1rem 0 0 0;
        color: #26336A;
    }
    .usedServiceBox .ServiceBoxItem.redFont figcaption {
        color: #9E1915;
    }
    .spanFontItem span {
        display: block;
        font-size: 2.4rem;
        line-height: 3.1rem;
        color: #26336A;
        position: absolute;
        white-space: nowrap;
        left: 50%;
        transform: translateX(-50%)
    }
    .aInner {
        width: 110rem;
        margin: 0 auto;
    }
    .aInner > div > p {
        letter-spacing: -0.815px;
        font-weight: 500;
    }
    .txtContents {
        padding: 4rem 0 3rem;
    }
    .txtContents h4 {
        color: #26336A;
        margin: 0 0 2rem 0;
    }
    .txtContents p {
        margin: 0 0 2rem 0;
    }
    .serviceVisionImgBox {
        padding: 4rem 0;
    }
    .serviceVisionImgBox img {
        object-fit: contain;
    }
    .serviceNeeds {
        padding: 0 0 9rem;
    }
    .serviceNeeds .title {
        padding: 4rem 0;
    }
    .serviceNeeds .title h3 {
        color: #26336A;
        text-align: center;
    }
    .leftRightPd > .nation:nth-child(odd) {
        padding: 0 6.5rem 0 0;
    }
    .leftRightPd > .nation:nth-child(even) {
        padding: 0 0 0 6.5rem;
    }
    .nationInfo {
        margin: 0 0 0 2rem;
    }
    .nationInfo h3 {
        margin: 0 0 1rem 0;
    }
    .nationInfoTxt {
        padding: 2rem 0;
        border-top: 1px solid #DCDCDC;
        border-bottom: 1px solid #DCDCDC;
    }
    .nationInfoTxt p:first-child {
        margin: 0 0 1rem 0;
    }
    .nationFlag {
        padding: 1.5rem 0 2rem;
    }
    .flexRow {
        margin: 0 0 13.5rem 0;
    }
    .nationInfoTxt.second {
        margin: -1px 0 0 0;
    }
    .marginTxt {
        margin: 0 0 1rem 0;
    }
    @media screen and (max-width: 560px) {
        .mobileOldConsumer .slick-slide img {
            margin: 0 auto;
        }
        .mobileOldConsumer {
            margin: 90px 0 76px;
        }
        .mobileOldConsumer figure figcaption {
            margin: 10px 0 60px 0;
            font-weight: bold;
            font-size: 30px;
            line-height: 72px;
            color: #26336A;
        }
        .aInner {
            width: 100%;
        }
        .txtContents {
            padding: 20px 0;
        }
        .txtContents h4 {
            color: #000000;
            text-align: center;
        }
        .movileServieVision {
            padding: 0 0 100px;
        }
        .serviceVisionImgBox {
            display: none;
        }
        .movileServieVision .slick-slide img {
            width: 100%;
        }
        .movileServieVisionImg {
            padding: 10px 0 30px;
        }
        .serviceNeeds {
            padding: 0;
        }
        .serviceNeeds .title {
            padding: 20px 0;
        }
        .serviceNeeds .title h3 {
            font-size: 20px;
            line-height: 35px;
        }
        .nationFlag {
            padding: 40px 0 20px;
        }
        .nationInfo h3 {
            margin: 20px 0 10px;
            text-align: center;
        }
        .nationInfo p {
            text-align: center;
        }
        .nationInfoTxt p {
            text-align: center;
        }
    }
</style>

<style>
</style>

